import { NavSubItem } from './nav-sub-item';

export class DefaultNavSubItem extends NavSubItem {}
